import React, { Component } from "react";
// import { Text } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import IframeModal from "../../react-components/iframe-modal";
import TabMenu from "../../react-components/tab-menu";
import AutoListContentItem from "../../react-components/Auto-List-Content-Item";
// import { lorem } from "../../utils/lorem";
import api from "../../utils/api";
import { format } from "../../utils";
// import { loader as gqlLoader } from "graphql.macro";
import GraphQLData from "../../lib/GraphQLData";
import gql from "graphql-tag";

const storiesQuery = gql`
  query storiesQuery($path: String = "/sitecore/content/lynkco-global-portal/Home/Stories") {
    datasource: item(path: $path) {
      name
      path
      children {
        name
        children {
          name
          url
          itemData: field(name: "itemData") {
            ...ItemField
          }
        }
      }
    }
  }
  fragment ItemField on ItemField {
    jss
  }
`;

class TabMenuContent extends Component {
  constructor(props) {
    super(props);
    const { fields } = this.props,
      { size, nestedGrid, tabMenuItems, IsColab } = fields;
    fields.arr = [];
    let tabMenu = [];
    if (!IsColab.value) {
      tabMenuItems.map(el => {
        tabMenu.push({ type: { value: el.fields.phrase.value.toUpperCase() } });
        return null;
      });
      tabMenu.unshift({ type: { value: "allstories" } });
    }
    this.state = {
      loading: true,
      tabMenu: tabMenu,
      listItems: [],
      listSize: 10,
      currentTabIndex: 0,
      currentPage: 1,
      pageSize: Number((size && size.value) || 10000),
      iframemodel: {
        show: false,
        isIframe: {},
        nestedGrid: nestedGrid && nestedGrid.value
      }
    };
  }
  toggleIframe(item) {
    const { iframemodel } = this.state;
    const { fields } = this.props;
    const { nestedGrid } = fields;
    let iframe = {
      id: "auto-list-content-model",
      isIframe: { href: "" },
      show: !iframemodel.show,
      nestedGrid: nestedGrid.value
    };
    if (!iframemodel.show) {
      iframe.isIframe.href = item.href;
    }
    this.setState({
      iframemodel: iframe
    });
  }
  componentDidMount() {
    const { pageSize, currentPage, tabMenu } = this.state;
    const { fields, lang } = this.props,
      { colabType, IsColab, colabOrderBy } = fields;
    const _this = this;
    let arr = [],
      sub1 = [],
      sub2 = [];
    _this.props.fields.subjects.map(el => {
      // sub.push(`<span class="type-h4">#${el.fields.phrase.value}</span>`);
      sub1.push(`#${el.fields.phrase.value.toUpperCase()}`);
      sub2.push(`${el.fields.phrase.value.toUpperCase()}`);
      return null;
    });

    if (IsColab.value) {
      api.colab
        .get({
          lang: lang,
          page: currentPage,
          size: pageSize,
          type: colabType ? colabType.fields.phrase.value : "",
          orderBy: colabOrderBy.fields.phrase.value
        })
        .then(res => {
          let rows = [];
          res.items.forEach((item, index) => {
            let subjects = [];
            item.subjects.forEach((it, index) => {
              if (sub1.includes(`${it.toUpperCase()}`) || sub2.includes(`${it.toUpperCase()}`)) {
                subjects.push({ fields: { phrase: { value: it } } });
              }
            });

            let obj = {
              type: { value: item.type },
              link: {
                value: {
                  href: item.link,
                  linktype: item.linktype
                }
              },
              image: {
                value: {
                  src: item.image && item.image.url,
                  alt: item.image && item.image.alt
                }
              },
              profileImage: {
                value: {
                  src: item.profileImage && item.profileImage.url,
                  alt: item.profileImage && item.profileImage.alt
                }
              },
              author: { value: item.author },
              // subjects:
              //   item.subjects &&
              //   item.subjects.map((its, indx) => {
              //     return { fields: { phrase: { value: its } } };
              //   }),
              subjects: subjects,
              timestamp: {
                value: format(item.timestamp, "yyyy-MM-ddTHH-mm-ss")
              },
              headingType: {
                fields: {
                  phrase: {
                    value: item.headingType
                  }
                }
              },
              headingBody: {
                value: item.headingBody
              }
            };
            rows.push(obj);
            this.props.fields.arr.push(obj);
            if (arr.indexOf(item.type) === -1) {
              arr.push(item.type);
            }
          });

          tabMenu.push({ type: { value: "allstories" } });
          for (let i = 0; i < arr.length; i++) {
            tabMenu.push({ type: { value: arr[i] } });
          }

          let listItems = rows;
          this.setState({
            listItems: listItems,
            loading: false
          });
        })
        .catch(err => {
          console.log(err);
        });
    }

    // this.props.fields.tabMenuItems.push({type:{value:"allstories"}})
  }

  goToTab = event => {
    // update selcted tab item (change color of tab)

    let selectedTabIndex = event.target.id;

    // update content shown
    // for demo porposes the listItems is modified but in a real solution new content should be fetched
    let newListItems = [];

    let currentType = this.state.tabMenu[selectedTabIndex].type.value;

    this.props.fields.arr.forEach(element => {
      if (element.type.value.toUpperCase() === this.state.tabMenu[event.target.id].type.value.toUpperCase()) {
        let newElement = { ...element, type: { value: currentType } };
        newListItems.push(newElement);
      }
      if (this.state.tabMenu[event.target.id].type.value === "allstories") {
        let newElement = { ...element, type: { value: element.type.value } };
        newListItems.push(newElement);
      }
    });
    this.setState({
      loading: false,
      listItems: newListItems,
      currentTabIndex: selectedTabIndex
    });
  };
  sortTime(list) {
    list.sort(function(prev, next) {
      let prev1 = null,
        next1 = null;
      prev1 = prev.timestamp.value.replace(/[A-z]/g, " ");
      prev1 = prev1.replace(/-/g, "/");
      next1 = next.timestamp.value.replace(/[A-z]/g, " ");
      next1 = next1.replace(/-/g, "/");
      return prev1 < next1 ? 1 : -1;
    });
    this.props.fields.arr = [...list];
  }
  selectQlData() {
    const { pageSize } = this.state;
    const { fields, storiesQuery } = this.props,
      { datasource } = storiesQuery,
      { tabMenuItems, IsColab, subjects } = fields;
    let QLdata = [],
      sub = [],
      stateItem = [];
    fields.arr = [];
    if (storiesQuery.loading || IsColab.value) {
      return null;
    }
    subjects.map(el => {
      sub.push(`${el.fields.phrase.value}`);
      return null;
    });
    QLdata = datasource.children.filter(el => {
      return tabMenuItems.find(item => {
        return item.fields.phrase.value.toUpperCase() === el.name.toUpperCase();
      });
    });
    QLdata = QLdata.filter(el => {
      return el.children;
    });
    QLdata.forEach(item => {
      item.children.forEach(child => {
        let { listTitle, backgroundImage, authorImage, author, subjects, date, headingType } = child.itemData.jss.fields;
        let itemschild = {
          type: { value: item.name },
          link: {
            value: {
              href: child.url,
              linktype: "internal"
            }
          },
          image: backgroundImage,
          profileImage: authorImage,
          author: author,
          subjects: subjects.filter(el => {
            return sub.includes(el.fields.phrase.value);
          }),
          timestamp: date,
          headingType: headingType,
          headingBody: listTitle
        };
        if (stateItem.length < pageSize) {
          stateItem.push(itemschild);
          fields.arr.push(itemschild);
        }
      });
    });
    this.sortTime(stateItem);
    return { stateItem, loading: false };
  }
  render() {
    if (!this.props.fields) return null;
    const { fields, rendering, storiesQuery } = this.props,
      { tabMenu, currentTabIndex, listItems, iframemodel, loading } = this.state;
    let list = listItems,
      loadingBol = loading,
      tabMenus = tabMenu;
    if (storiesQuery.loading) {
      // this.setState({
      //   loading:true
      // })
      return null;
    } else if (loadingBol) {
      let QlData = this.selectQlData();
      list = QlData ? QlData.stateItem : [];
    }
    return (
      <div className={"tab-menu-content grid"} datasourceid={rendering.dataSource}>
        <TabMenu
          tabMenu={{
            items: tabMenus,
            selectedTabIndex: currentTabIndex
          }}
          onTabClicked={this.goToTab.bind(this)}
        />
        <div className={"content-container"}>
          {list &&
            list.map((item, index) => {
              return <AutoListContentItem fields={item} key={index} toggleIframe={item => this.toggleIframe(item)} showModal={fields.showModal} />;
            })}
        </div>
        {iframemodel.show && <IframeModal {...iframemodel} toggleIframe={item => this.toggleIframe(item)} />}
      </div>
    );
  }
}
export default GraphQLData(storiesQuery, { name: "storiesQuery" })(TabMenuContent);
